import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const Divider = ({vertical, styleName}) => {
  return (
    <div className={classNames(
      "Divider",
      styleName, {
        "Divider--horizontal": !vertical,
        "Divider--vertical": vertical,
      })}
    />
  );
};

Divider.propTypes = {
  vertical: PropTypes.bool,
  styleName: PropTypes.string,
};

Divider.defaultProps = {
  vertical: false,
};

export default Divider;



// WEBPACK FOOTER //
// ./src/components/Divider.js